import type { PlantAssessment } from '@/features/assessments/api/assessment-list'

export type RowClickAction = 'navigate' | 'start' | 'none'

export function resolveRowClickAction(
  assessment: Pick<PlantAssessment, 'status'> | undefined | null,
  clickTarget: HTMLElement | undefined,
  // With multiPhase there is no Start step: every row opens the assessment.
  multiPhase = false
): RowClickAction {
  if (!assessment) return 'none'
  if (clickTarget?.closest('[data-actions-cell]')) return 'none'
  if (!multiPhase && assessment.status === 'pending') return 'start'
  return 'navigate'
}
